import React from 'react';

import {
  WORK_STATUSES_DISPLAY,
  RESOLUTION_STATUSES_DISPLAY,
} from '../constants';

export const WORK_STATUS_CHOICES = {
  notStarted: {
    value: 'notStarted',
    label: WORK_STATUSES_DISPLAY.notStarted,
    helpText: <span>Work has not yet started on this issue.</span>,
  },
  planned: {
    value: 'planned',
    label: WORK_STATUSES_DISPLAY.planned,
    helpText: (
      <span>Work will be started on this issue in the next month.</span>
    ),
  },
  inProgress: {
    value: 'inProgress',
    label: WORK_STATUSES_DISPLAY.inProgress,
    helpText: <span>This issue is being actively worked on.</span>,
  },
  done: {
    value: 'done',
    label: 'Done',
    helpText: <span>This issue should be closed.</span>,
  },
};

export const RESOLUTION_STATUS_CHOICES = [
  {
    value: 'resolved',
    label: RESOLUTION_STATUSES_DISPLAY.resolved,
  },
  {
    value: 'wontDo',
    label: RESOLUTION_STATUSES_DISPLAY.wontDo,
  },
  {
    value: 'duplicate',
    label: RESOLUTION_STATUSES_DISPLAY.duplicate,
  },
  {
    value: 'cannotReproduce',
    label: RESOLUTION_STATUSES_DISPLAY.cannotReproduce,
  },
];
